// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT DIRECTLY.

export enum QuestionVisibility {
    ALL,
    ACCOUNT_USERS,
    HOSTS,
    INTERNAL

}
export default QuestionVisibility
